import React from 'react';
import { string, shape, number } from 'prop-types';
import { useDispatch } from 'react-redux';
import { dismissFollowRequest } from '../../../../../ducks/followerRequests';
import IconClose16 from '../../../../../../../components/svg/shared/IconClose16';
import styles from './styles/styles.module.scss';
import Button from '../../../../../../../components/shared/Button';

const AcceptDismissButtons = ({ accept, dismiss, userId }) => {
  const dispatch = useDispatch();

  const handleDismissClick = () => {
    dispatch(dismissFollowRequest(userId, dismiss.href));
  };
  const handleAcceptClick = () => {
    // TODO: Hook into belay https://alltrails.atlassian.net/browse/SVR-4937
  };

  return (
    <div className={styles.container}>
      <Button variant="primary" classes={styles.acceptButton} onClick={handleAcceptClick}>
        {accept.title}
      </Button>
      <Button classes={styles.dismissButton} onClick={handleDismissClick}>
        <IconClose16 />
      </Button>
    </div>
  );
};

AcceptDismissButtons.propTypes = {
  accept: shape({
    title: string,
    href: string,
    description: string
  }).isRequired,
  dismiss: shape({
    title: string,
    href: string,
    description: string
  }).isRequired,
  userId: number.isRequired
};

export default AcceptDismissButtons;
